import(/* webpackMode: "eager" */ "/Users/frank/Documents/git/nimble-monorepo/monorepo/frontend/apps/review-links/src/app/error.tsx");
